import { useQuery } from '@tanstack/react-query'
import {
  getFeesReport,
  getValueReport,
  getTopProducts,
  type DateRangeParams,
  type ValueParams,
  type TopProductsParams,
} from '@/lib/api/reports'

/**
 * Reports queries (Screen 4). Each panel is an independent query keyed on its
 * own params, so one panel failing never blanks the others. Blank date params
 * fall through to the server defaults.
 */

export function useFeesReport(params: DateRangeParams) {
  return useQuery({
    queryKey: ['reports', 'fees', params.start ?? '', params.end ?? ''],
    queryFn: () => getFeesReport(params),
    staleTime: 30_000,
  })
}

export function useValueReport(params: ValueParams) {
  return useQuery({
    queryKey: ['reports', 'value', params.start ?? '', params.end ?? '', params.compare ?? false],
    queryFn: () => getValueReport(params),
    staleTime: 30_000,
  })
}

export function useTopProducts(params: TopProductsParams) {
  return useQuery({
    queryKey: ['reports', 'top-products', params.start ?? '', params.end ?? '', params.sort ?? 'units'],
    queryFn: () => getTopProducts(params),
    staleTime: 30_000,
  })
}
